import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import TitledPanel from '../TitledPanel';
import SearchSelect from '../../core/SearchSelect';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import CreateButton from '../CreateButton';
import { globalStyles as styles } from '../style/gstheme';
import { Typography } from '@material-ui/core';

class FindProjectDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            lang: props.defaultLang,
        };
    }

    handleClickOpen = () => this.setState({ open: true });

    changeLanguage = (lang) => this.setState({ lang });

    computeSearch = (value, lang) => {
        let fullSearch =
        {
            search: [
                {
                    predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                    value: "https://grafsync.graphifi.com/schema/gs/OntologyProject"
                },
                {
                    predicate: "https://grafsync.graphifi.com/schema/gs/isVersionOfProject",
                    invert: true
                },
                {
                    predicate: "http://purl.org/dc/terms/title",
                    value: value,
                    isExactMatch: false
                }
            ],
            excludeByPath: [
                {
                    predicate: [
                        "https://grafsync.graphifi.com/schema/vm/ontologyProjectAssociation",
                        "https://grafsync.graphifi.com/schema/vm/associatedProject"
                    ],
                    target: this.props.project,
                    targetGraph: this.props.graph,
                    reverse: true
                }
            ],
            language: lang,
            pageSize: 20,
            ignoreNoLanguage: lang !== "und",
            sort: ["http://purl.org/dc/terms/title"],
            searchMode: "Compliant",
            predicates: ["http://purl.org/dc/terms/title"]
        };
        return fullSearch;
    };

    addProject = (id) => {
        this.props.onAddProject(id);
        this.exitAddProject();
    };

    exitAddProject = () => this.setState({ open: false, lang: this.props.defaultLang });

    render() {

        const { classes } = this.props;
        const { lang } = this.state;

        return (
            <React.Fragment>
                <CreateButton dataTest="add-ontology-project" onClick={() => this.handleClickOpen()} label="Add project" />
                <Dialog
                    data-test="add-ontology-project-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.smallDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    onClose={this.exitAddProject}
                    aria-labelledby="find-project-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="find-project-dialog-title">Add Project</DialogTitle>
                    <DialogContent style={{ height: '460px', overflow: 'visible' }}>
                        <TitledPanel dataTest="project-language" title="Language">
                            <ProjectLanguageSelector includeLabel={false} onSelect={this.changeLanguage} />
                        </TitledPanel>
                        <div style={{ height: 360 }}>
                            <SearchSelect
                                key={lang}
                                dataTest="find-project"
                                focus={true}
                                sortProp="title"
                                wrapped={true}
                                search={(value, lang) => this.computeSearch(value, lang)}
                                listDisplay={(result, lang) => {
                                    if (result.title[lang]) {
                                        return <div>
                                            <Typography data-test="result-label" variant="body2">
                                                <Tooltip placement="left" title={result.id}>
                                                    <span>
                                                        {result.title[lang]}
                                                    </span>
                                                </Tooltip>
                                            </Typography>
                                        </div>;
                                    }
                                    else {
                                        return <Typography data-test="result-label" variant="body2">No title available</Typography>;
                                    }
                                }}
                                isClickableResult={(result) => {
                                    if (result.invalid) return false;
                                    return true;
                                }}
                                title="Filter projects"
                                lang={lang}
                                chosen={this.addProject} />
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddProject} />
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

FindProjectDialog.propTypes = {
    classes: PropTypes.object,
    project: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    onAddProject: PropTypes.func.isRequired
};

export default withStyles(styles)(FindProjectDialog);